export const transformInOptions = <T extends { id: string | number; name?: string }>(
  data: T[] = [],
  options: { getValue?: (item: T) => string; getLabel?: (item: T) => string } = {}
) => {
  const { getValue, getLabel } = options;

  return data.map((item) => ({ label: getLabel?.(item) ?? item.name ?? "N/A", value: getValue?.(item) ?? String(item.id) })) || [];
};
